export const MAX_ATTACHMENTS = 5;
export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;
export const MAX_ATTACHMENTS_TOTAL_SIZE = 25 * 1024 * 1024;

/**
 * Extensões aceitas na abertura do chamado e nas atualizações.
 * A lista é um espelho de ExtensoesPermitidas em ChamadosController.cs:
 * executáveis, scripts e atalhos ficam de fora.
 */
export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  ".png", ".jpg", ".jpeg", ".webp", ".gif", ".bmp", ".tif", ".tiff", ".heic",
  ".pdf", ".doc", ".docx", ".odt", ".rtf", ".txt", ".md", ".log",
  ".xls", ".xlsx", ".xlsm", ".ods", ".csv",
  ".ppt", ".pptx", ".odp",
  ".eml", ".msg",
  ".xml", ".json",
  ".zip", ".rar", ".7z",
];

export const ATTACHMENT_ACCEPT = ALLOWED_ATTACHMENT_EXTENSIONS.join(",");

export function attachmentExtension(name: string) {
  const dot = name.lastIndexOf(".");
  return dot < 0 ? "" : name.slice(dot).toLowerCase();
}

export function isAllowedAttachment(name: string) {
  return ALLOWED_ATTACHMENT_EXTENSIONS.includes(attachmentExtension(name));
}

export function isImageAttachment(name: string) {
  return [".png", ".jpg", ".jpeg", ".webp", ".gif", ".bmp"].includes(
    attachmentExtension(name),
  );
}

export function formatFileSize(size: number) {
  if (size < 1024 * 1024) return `${Math.ceil(size / 1024)} KB`;
  return `${(size / 1024 / 1024).toFixed(1)} MB`;
}
